import { useMutation } from '@tanstack/react-query';
import { Contact } from '../../../types/Contact';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { mutationKeys } from '../mutationKeys';

export const updateContact = async (uuid: string, formData: Contact) => {
  const response = await CustomAxios.put(`contacts/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateContactFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}
export function useUpdateContact({ uuid, onSuccessCallback }: UseUpdateContactFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateContact],
    mutationFn: (formData: Contact) => updateContact(uuid, formData),
    onSuccess: (data: Contact) => {
      // fetch the contact again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allContacts, data.uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const contact: Contact = err.response.data as Contact;
        queryClient.setQueryData([queryKeys.allContacts, contact.uuid], contact);
      }
    },
  });
}
